/**
 * props: { limit?: number, sorting?: { by: string, order: string } }
 */
export const queryFilter = props => {
    let filter = null;

    if (Object.prototype.hasOwnProperty.call(props, 'limit')) {
        if (!filter) {
            filter = {};
        }
        filter.limit = props.limit;
    }

    if (Object.prototype.hasOwnProperty.call(props, 'sorting')) {
        if (!filter) filter = {};
        filter.sorting = props.sorting;
    }

    return filter;
};

/**
 * objectStore: { [key: string]: { id: string, ... } }
 * orderSettings: { by: string, order: string }
 */
export const sortObjects = (objectStore, orderSettings) => {
    const orderBy = orderSettings.by || 'id';
    const orderDirection = (orderSettings.order || 'ASC') === 'ASC' ? 1 : -1;

    return Object.keys(objectStore)
      .map(key => objectStore[key])
      .sort((item1, item2) => {
          if (item1[orderBy] < item2[orderBy]) {
              return -orderDirection;
          }
          if (item1[orderBy] > item2[orderBy]) {
              return orderDirection;
          }
          return 0;
      });
};

const filterCache = new WeakMap();

/**
 * objectStore: { [key: string]: object }
 * filter: { limit?: number, sorting?: object } | null
 */
export const filterObjectStore = (objectStore, filter = null) => {
    if (!objectStore) {
        return [];
    }

    if (filterCache.has(objectStore)) {
        const cached = filterCache.get(objectStore);
        if (JSON.stringify(cached.filter) === JSON.stringify(filter)) {
            return cached.result;
        }
    }

    let result;

    if (filter === null) {
        result = Object.keys(objectStore).map(key => objectStore[key]);
    }
    else if (
      Object.prototype.hasOwnProperty.call(filter, 'limit') &&
      filter.sorting
    ) {
        result = sortObjects(objectStore, filter.sorting).slice(0, filter.limit);
    }
    else if (Object.prototype.hasOwnProperty.call(filter, 'limit')) {
        result = Object.keys(objectStore)
          .map(key => objectStore[key])
          .slice(0, filter.limit);
    }
    else if (filter.sorting) {
        result = sortObjects(objectStore, filter.sorting);
    }
    else {
        result = Object.keys(objectStore).map(key => objectStore[key]);
    }

    filterCache.set(objectStore, { filter, result });

    return result;
};
